import type React from "react";

import { PATH_SUPERADMIN } from "src/routesConstants";
import type { Pos } from "src/types/pos";

import { LinkWithIcon } from "./LinkWithIcon";

interface PosLinkProps {
    pos: Pos;
    Icon?: JSX.Element;
    className?: string;
}

export const PosLink: React.FC<PosLinkProps> = ({ pos, Icon, className }): JSX.Element => (
    <LinkWithIcon to={`${PATH_SUPERADMIN}/pos/${pos.id}`} Icon={Icon} className={className}>
        {pos.name}
    </LinkWithIcon>
);
